
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class ReceiptDialog extends _Ext.TransDialog<ReceiptRow, any> {
        protected getFormKey() { return ReceiptForm.formKey; }
        protected getIdProperty() { return ReceiptRow.idProperty; }
        protected getLocalTextPrefix() { return ReceiptRow.localTextPrefix; }
        protected getNameProperty() { return ReceiptRow.nameProperty; }
        protected getService() { return ReceiptService.baseUrl; }
        protected getDeletePermission() { return ReceiptRow.deletePermission; }
        protected getInsertPermission() { return ReceiptRow.insertPermission; }
        protected getUpdatePermission() { return ReceiptRow.updatePermission; }
        protected useViewMode() { return true; }

        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        } 
        public form = new ReceiptForm(this.idPrefix); 
        constructor() {
            super();

            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 200;
            q.initItemEditor(this, this.form.ReceiptDetails, Config);
            q.initDetailEditor(this, this.form.PartyBalance, Config);
            // q.setTextRightAlign(this.form.TdsTotal.element);
            q.hideEditorTab(this.form.ReceiptDetails);
            q.hideEditorLabel(this.form.ReceiptDetails);
            q.hideEditorLabel(this.form.PartyBalance);
            //q.setGridEditorHeight(this.form.ReceiptDetails.element, 100);
            q.setTextRightAlign(this.form.TotalAmount);
            q.setTextRightAlign(this.form.KnockOffTotal);
            //Remove toolbar of PartyBalance Grid
            this.form.PartyBalance.getGridField().find('.grid-toolbar').attr("style", "display:none;");

            this.form.IsAdvance.changeSelect2(e => {
                if (this.form.IsAdvance.value) {
                    this.form.PartyBalance.element.hide();
                    this.form.KnockOffTotal.getGridField().toggle(false);
                } else {
                    this.form.PartyBalance.element.show();
                    this.form.KnockOffTotal.getGridField().toggle(true);
                }
                if (this.form.ReceiptDetails.getItems().length > 0) {
                    this.form.IsAdvance.value = false;
                }
            });

            this.form.POSCustomerId.changeSelect2(e => {

                var ledgerid = parseInt(this.form.POSCustomerId.value);
                this.form.PartyBalance.clearGrid();
                if (q.isNumber(ledgerid)) {
                    //set Party Balance Grid based on Ledger Id
                    this.form.PartyBalance.setCustomerBalance(ledgerid); 
                }

            });
            this.form.CurrencyId.changeSelect2(e => {
                //set Exchange Rate feild of Detail Grid Dialog
                var exchangerate = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() === this.form.CurrencyId.value);
                this.form.ReceiptDetails.exchangerate = exchangerate[0].ExchRate;
                //new paymentdetailsdialog().exchangerate = 1;
                Q.Authorization.userDefinition.exchangerate = exchangerate[0].ExchRate;
            });
            (this.form.ReceiptDetails.view as any).onDataChanged.subscribe(() => {
                //set Total Amount on Payment Grid Change

                var amt = 0;
                for (var k of this.form.ReceiptDetails.getItems()) {
                    amt += k.Amount;
                }
                this.form.TotalAmount.value = amt;
                //if (this.form.TaxId.value != "") {
                //    var taxrate = OMS.TaxRow.getLookup().itemById[this.form.TaxId.value].Rate;
                //    var tdsamt = this.form.TotalAmount.value * (taxrate / 100);
                //    this.form.TdsTotal.value = tdsamt;

                //} 
            });

            var Items: any;
            (this.form.ReceiptDetails.view as any).onRowCountChanged.subscribe(() => {
                //set Total Amount on Payment Grid Change
                this.CalculateTotals
            });

            //this.form.TaxId.changeSelect2(e => {
            //    //Calculate Tax Values on the Payments in the Detail Grid
            //    if (this.form.TaxId.value != "") {
            //        var taxrate = OMS.TaxRow.getLookup().itemById[this.form.TaxId.value].Rate;
            //        this.form.Rate.value = taxrate;
            //        var tdsamt = this.form.TotalAmount.value * (taxrate / 100);
            //        this.form.TdsTotal.value = tdsamt;
            //        this.form.TaxLedgerId.value = OMS.TaxRow.getLookup().itemById[this.form.TaxId.value].LedgerId;
            //    }
            //});

            this.form.KnockOffTotal.addValidationRule(this.uniqueName, e => {
                //Validate that the knock off value is not less than or greater than total Amount
                if (!this.form.IsAdvance.value) {
                    if (this.form.KnockOffTotal.value != this.form.TotalAmount.value) {
                        return "knock off values and total amount should match";
                    }
                }
            });
            this.validateForm();
        }

        public CalculateTotals() {

            if (this.form != undefined) {
                var amt = 0;
                for (var k of this.form.ReceiptDetails.getItems()) {
                    amt += k.Amount;
                }
                this.form.TotalAmount.value = amt;
                //     alert(this.form.TaxId.value);
                //if (this.form.TaxId.value != "") {
                //    var taxrate = OMS.TaxRow.getLookup().itemById[this.form.TaxId.value].Rate;
                //    var tdsamt = this.form.TotalAmount.value * (taxrate / 100);
                //    this.form.TdsTotal.value = tdsamt;

                //}

                //alert('diaolg' + amt); 

            }
            if (this.form.ReceiptDetails.getItems().length > 0) {
                this.form.POSCustomerId.set_readOnly(true);
                this.form.IsAdvance.value = false;
            } else {
                this.form.POSCustomerId.set_readOnly(false);
            }
        }
        public calculatePartyBalance() {
            //calculate knock off value of the Knock Off Grid/Party Balance Grid
            var ntamt = 0;
            var dueamt = 0;
            for (var x of this.form.PartyBalance.getItems()) {
                if (x.KnockOff != undefined) {
                    ntamt = ntamt + x.KnockOff;
                }
                dueamt = dueamt + x.Due;
            }
            this.form.KnockOffTotal.value = ntamt; 
        }
        /*protected onDialogOpen() {

            /*Q.Authorization.userDefinition.UserId
            this.form.EnteredBy.value = Q.Authorization.userDefinition.Username;
            Serenity.EditorUtils.setReadOnly(this.form.EnteredBy, true);
            this.form.UserId.value = Q.Authorization.userDefinition.UserId;

            if (this.form.LedgerId.value > "0") {
                var ledgerid = parseInt(this.form.LedgerId.value);
                var voucherno = this.form.VoucherNo.value;
            //    this.form.PartyBalance.setPartyBalanceforEdit(ledgerid, voucherno);
                //for (var x of this.form.PartyBalance.getItems()) {
                //    Serenity.EditorUtils.setReadOnly(x, true);
                //    if (x. != undefined) {
                //        ntamt = ntamt + x.KnockOff;
                //    }
                //    //  alert(ntamt);
                //}
            }

        }*/

        protected onDialogOpen() {
            super.onDialogOpen();

            if (this.form.POSCustomerId.value != "") {
                //set Party Balance Grid in Edit Mode
                let values; 
                //ReceiptService.KnockOffvalues({}, response =>
                //    values = response,
                //    { async: false });
                //if (values[0] == 0) {
                //    ReceiptDetailsDialog.lock = false;
                //    this.canDelete = true;
                //} else {
                //    ReceiptDetailsDialog.lock = true;
                //    this.canDelete = false;
                //}
                var exchangerate = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() === this.form.CurrencyId.value);
                this.form.ReceiptDetails.exchangerate = exchangerate[0].ExchRate;
                //new paymentdetailsdialog().exchangerate = 1;
                Q.Authorization.userDefinition.exchangerate = exchangerate[0].ExchRate;
              
                this.form.IsAdvance.changeSelect2(e => {
                    if (this.form.IsAdvance.value) {
                        this.form.PartyBalance.element.hide();
                        this.form.KnockOffTotal.element.hide();
                    } else {
                        this.form.PartyBalance.element.show();
                        this.form.KnockOffTotal.element.show();
                    }
                    if (this.form.ReceiptDetails.getItems().length > 0) {
                        this.form.IsAdvance.value = false;
                    }
                });
            }
            else { 
                //set Default Values based on Login 
                var exchangerate = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() === this.form.CurrencyId.value);
                this.form.ReceiptDetails.exchangerate = exchangerate[0].ExchRate;
                //new paymentdetailsdialog().exchangerate = 1;
                Q.Authorization.userDefinition.exchangerate = exchangerate[0].ExchRate; 
            } 

        } 
        protected getToolbarButtons(): Serenity.ToolButton[] {
            var buttons = super.getToolbarButtons();
            //var temp = [];

            //let newBtn: Serenity.ToolButton =
            //{
            //    title: '',
            //    cssClass: 'panel-titlebar-close',
            //    icon: 'fa-arrow-left',
            //    onClick: () => {

            //        this.dialogClose();

            //    },
            //}
            //temp.push(newBtn);
            //Remove Buttons
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "undo-delete-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "localization-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "clone-button"), 1);

            //for (let btns of buttons) {
            //    temp.push(btns);
            //}
            //buttons.push(
            //    {
            //        title: 'Cancel',
            //        cssClass: 'stampe',
            //        icon: 'fa-times',
            //        onClick: () => {

            //            this.dialogClose();

            //        },
            //    }
            //);
            //Edit Click Override
            var btnEdit = Q.first(buttons, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };

            var btnDelete = Q.first(buttons, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };
            //Report Generation Button
            buttons.push(TabAurous.Common.ReportHelper.createToolButton({
                title: 'Print',
                cssClass: 'export-pdf-button',
                icon: 'fa fa-print text-blue',
                reportKey: 'Finance.Receipt',
                getParams: () => ({
                    TransId: this.get_entityId()
                })
            }));
            return buttons;
        }

        protected updateTitle() {

            //get Back Button on the Dialog
            this.dialogTitle = "Receipt Voucher";
        }
        private confirmBeforeEdit(oldEvt, e) {
            let self = this;
            var refid = self.entity.RefVoucherId;
            //Stock.StockItemService.CheckTransaction(
            //    { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
            //    response => {
            //        if (response.Entities != null && response.Entities.length > 0)
            //            refid = response.Entities[0];
            //    }, { async: false }
            //)
            if (refid != null) {
                q.Alert("Can not Delete!", "This Voucher has been used in transactions", 2500, false);
                return;
            } else {
                Serenity.EditorUtils.setReadonly(this.form.ReceiptDetails.element, false);
                //this.form.ReceiptDetails.canUpdate = 1;
                if (!self.isEditMode())
                    return;
                self.editClicked = true;
                self.updateInterface();
                self.updateTitle();
            }
        }
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            //if (this.canDelete) {
                ReceiptService.Delete(
                    {

                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            //} else {
            //    Q.alert("Further Payments for the Vouchers have been made, Cannot delete");
            //    return;
            //}

        }


    }




}
